<template>
    <div class="support-widget">
      <div class="support-button"
           @mouseenter="showQRCode = true"
           @mouseleave="hideQRCode()">
        GB WhatsApp QR Code
      </div>
      <div v-show="showQRCode" class="qr-code-container"
           :class="{ 'qr-code-enter': showQRCode }">
        <img src="@/assets/gbwhatsapp-qr-code-gbwhatapks.webp" alt="QR Code for download GB WhatsApp" />
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: "SupportWidget",
    data() {
      return {
        showQRCode: false,
        animationTimeout: null
      };
    },
    methods: {
      hideQRCode() {
        // 添加延迟，使动画更流畅
        this.animationTimeout = setTimeout(() => {
          this.showQRCode = false;
        }, 200);
      }
    },
    beforeDestroy() {
      // 清理定时器防止内存泄漏
      if (this.animationTimeout) clearTimeout(this.animationTimeout);
    }
  };
  </script>
  
  <style lang="scss">
  $--group-option-flex: 0 calc(1 / 5) * 100%!default;
  .support-widget {
    position: fixed;
    bottom: 30px;
    right: 30px;
    z-index: 9999;
    display: flex;
    flex-direction: column;
    align-items: center;
    
    .support-button {
      cursor: pointer;
      background: linear-gradient(135deg, #b6faff, rgb(42, 130, 228));
      padding: 12px 20px;
      border-radius: 6px;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
      font-weight: 500;
      transition: all 0.3s ease;
      z-index: 2;
      
      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);
      }
    }
    
    .qr-code-container {
      position: absolute;
      bottom: 60px;
      right: 0;
      background-color: white;
      border-radius: 8px;
      box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
      padding: 10px;
      opacity: 0;
      transform: translateY(20px);
      transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
      pointer-events: none;
      
      img {
        display: block;
        max-width: 180px;
        border-radius: 4px;
      }
      
      // 箭头
      &::after {
        content: '';
        position: absolute;
        bottom: -10px;
        right: 20px;
        border-width: 10px 10px 0;
        border-style: solid;
        border-color: white transparent transparent;
      }
    }
    
    // 二维码进入动画
    .qr-code-enter {
      opacity: 1;
      transform: translateY(0);
    }
  }
  @media (max-width: 768px) {
    .support-widget{
      // right: 50vw;
    }
  }
  </style>